/**
 * Default: Modules > Mindshape Cookie Consent
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Data from '@ifabnpm/bootstrap/dom/data.js';

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';

import CatMedia from './categories/media';
import CatStatistics from './categories/statistics';

const CONSENT_BUTTON = SelectorEngine.findOne('button[data-cookie-consent="trigger"]');
const PRIVACY_CONSENT_BUTTONS = SelectorEngine.find('.privacy-info .privacy-info__button');

// -------
// Private
// -------

const registerEvents = () => {
	window.addEventListener('cookieConsent', function() {
		initCategories();
		unlockBodyScrolling(CONSENT_BUTTON);
	});

	// initialize cookie toggle
	if (!Data.get(CONSENT_BUTTON, 'initialized'))
	{
		EventHandler.on(CONSENT_BUTTON, 'click', () => {
			lockBodyScrolling(CONSENT_BUTTON);
		});

		if (PRIVACY_CONSENT_BUTTONS.length)
		{
			for (let element of PRIVACY_CONSENT_BUTTONS)
			{
				EventHandler.on(element, 'click', () => {
					EventHandler.trigger(CONSENT_BUTTON, 'click', {});
				});
			}
		}

		Data.set(CONSENT_BUTTON, 'initialized', true);
	}
};

const isFirstAppearance = () => {
	return !window.cookieConsent.consent;
};

// -------
// Public
// -------

const checkCookieConsentStatus = () => {
	if (!window.cookieConsent) return false;

	return !!window.cookieConsent.consent;
};

const initCategories = () => {
	CatMedia.init();
	// CatStatistics.init();
};

const init = () => {
	if (isFirstAppearance())
	{
		lockBodyScrolling(CONSENT_BUTTON);

		EventHandler.trigger(CONSENT_BUTTON, 'click', {});
	}

	registerEvents();

	if (checkCookieConsentStatus())
	{
		initCategories();
	}
};

// -------
// Export
// -------

export default {
	init: init,
	initCategories: initCategories,
	checkCookieConsentStatus: checkCookieConsentStatus
};

